const commonActionController = require('frontend-controller/lib/controllers/common')

module.exports = {
    events: {
        logout: {
            selector: '.logout',
            type: 'click',
            action: event => {
                const self = ((event || {}).data || {}).component
                if(self){
                    self.logout()
                }
            }
        },
        heartbeatConnect: {
            selector: '.heartbeatConnection',
            type: 'click',
            action: event => {
                heartbeatController.reconnect(true)
            }
        },
        showAdminPanel: {
            selector: 'button',
            type: 'click',
            action: event => {
                const self = event.data.component
                const $target = $(event.target).closest('button')
                if($target.length > 0){
                    if($target.data('fieldType') === 'showAdminPanel'){
                        self.showAdminPanel()
                    }
                }
            }
        }
    },

    methods: {
        logout(){
            return this.performAction(
                this.prepareAction(commonActionController.getAction('logout'))
            )
        },

        heartbeatConnectionStateChanged(connected){
            if(connected){
                this.$.find('.heartbeatConnection').addClass('connected')
            } else {
                this.$.find('.heartbeatConnection').removeClass('connected')
            }
        },

        async showAdminPanel(){
            await this.performAndStoreAction(
                'showAdminPanel_inEffect',
                this.prepareAction('showAdminPanel')
            )
        },
    },

    handlers: [
        {
            name: 'heartbeat.connectionStateChanged',
            handle: function(callerComponent, connected){
                this.heartbeatConnectionStateChanged(connected)
            }
        },
    ]
}